var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#16406E",
    d: "M11.952 5.196L5.93 8.676v.113l1.725-.945l.17.171h.012l1.008-.53l.12.24l3.672-2.134zm.94.541L5.935 9.746v.17L7.66 8.91l.17.24l1.966-1.13l.12.239l3.692-2.11zm.994.573l-7.95 4.563v.114l1.725-.945l.17.233h.006l2.91-1.72l.119.24l3.68-2.106zm.945.544l-8.901 5.09v.17l1.725-1.007l.17.238h.012l3.86-2.191l.12.176l3.673-2.097zm.935.538l-9.83 5.673v.125l1.725-.95l.17.176h.006l4.811-2.733l.12.177l3.707-2.06zm.935.539L5.936 14.14v.177L7.66 13.31l.17.233h.006l5.762-3.325l.12.24l3.696-2.116zm.94.541L5.937 15.268v.114l1.725-.945l.17.24l5.767-3.388l.12.239L18 9.09v-.413zm-9.98 7.035l-.951.592l-.182-.12L18 9.383v.78l-4.281 2.493l-.12-.239l-5.825 3.325zm6.058-1.725l-.12-.239l-4.817 2.733l-.17-.233l-.951.586l-.182-.057L18 10.462v.764zm-4.1 2.853l-1.008.535l-.005-.006l-.17-.057L18 11.585v.774l-4.281 2.494l-.114-.24l-3.872 2.26zm.95.535l-1.007.535v-.011l-.182-.057L18 12.655v.832l-4.281 2.493l-.12-.24l-2.915 1.669zm-.062 1.127l-.176-.12L18 13.783v.774l-4.281 2.493l-.12-.239l-1.965 1.128l-.113-.234zm1.902-.057l-.951.592l-.12-.057L18 14.853v.832l-4.281 2.493l-.12-.24l-1.008.536z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRen);
export default __webpack_public_path__ + "static/media/ren.340c3e27d9082e5fc316abba52103ba9.svg";
export { ForwardRef as ReactComponent };